import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export const options = {
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    options: {
      customProperties: true,
    },
    dark: false,
    themes:{
      light: {
        //Corporate Color
        sky: '#cce8ff',
        shallowAqua: '#99D1FF',
        aqua: '#99D1FF',
        deepAqua: '#008CFF',
        abyss: '#294A66',
        //Achromatic Color
        ink: '#2B2B2B',
        cloud: '#707070',
        shallowCloud: '#dcdcdc',
        //Prominent Color
        faintLava: '#FF8796',
        deepLava: '#BA0009',
        lava: '#E64550',
        faintHoney: '#FFB336',
        honey: 'FF9E40',
        deepHoney: 'E05922',
        faintAlgae: '#B6E3BA',
        algae: "#54E363",
        deepAlgae: '#399942'
      },
    }
  }
}


export default new Vuetify(options);
